import type { ControllerParams } from '@wix/yoshi-flow-editor';

import * as search from 'store/search';
import type { ISearchParams } from 'store/search/types';

import type { IRootStore } from 'store/index';

export function SearchVM(params: ControllerParams, store: IRootStore) {
  return {
    search$: {
      query,
    },
  };

  function query(params: ISearchParams) {
    return store.dispatch(search.thunks.query(params));
  }
}

export type ISearchVM = ReturnType<typeof SearchVM>;
